import React from 'react'

export default function TalkToSpecialist2() {
  return (
    <iframe
      title="Talk to a Specialist"
      src="https://go.xealenergy.com/l/1095552/2025-06-17/n2srg"
      width="100%"
      height="725"
      type="text/html"
      frameborder="0"
      allowTransparency="true"
      style={{ border: 0, aspectRatio: '11/16' }}
    ></iframe>
  )
}
